<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم ویرایش اطلاعات پرسنلی</h5>
    <form [formGroup]="EditNewPerson">

      <input type="hidden" formControlName="id" />

      <br>
      <br>
      <h4>اطلاعات پرسنلی</h4>
      <br>

      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">نام (*)</label>
          <input formControlName="fname" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_fname().valid && get_Form_fname().touched"
            class="form-text text-muted MyErrorRedColor">نام را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">نام خانوادگی (*)</label>
          <input formControlName="lname" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_lname().valid && get_Form_lname().touched"
            class="form-text text-muted MyErrorRedColor">نام خانوادگی را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> جنسیت </label>
          <select class="custom-select" formControlName="sex">
            <option value="0">انتخاب کنید</option>
            <option value="1">مرد</option>
            <option value="2">زن</option>
          </select>
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">وضیعت تأهل</label>
          <select class="custom-select" formControlName="vaziat_Tahol">
            <option value="0">انتخاب کنید</option>
            <option value="1">متأهل</option>
            <option value="2">مجرد</option>
          </select>
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">استان </label>
          <select class="custom-select" formControlName="ProvinceId" (change)="ProvinceChange()">
            <option value="0">انتخاب کنید</option>
            <option *ngFor="let item of DataList_Province" [value]="item.code">{{item.title}}</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">محل صدور</label>
          <select class="custom-select" formControlName="mahal_tavalod">
            <option value="0">انتخاب کنید</option>
            <option *ngFor="let item of DataList_City" [value]="item.id">{{item.title}}</option>
          </select>
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">شماره شناسنامه</label>
          <input formControlName="shomareh_Shenasnameh" type="number" class="form-control"
            placeholder="اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">شماره سری شناسنامه</label>
          <input formControlName="shomareh_Shenasnameh_Seri" type="text" class="form-control"
            placeholder="اینجا تایپ کنید ...">
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">کد ملّی (بدون صفر اول)</label>
          <input formControlName="codeMeli" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_codeMeli().valid && get_Form_codeMeli().touched"
            class="form-text text-muted MyErrorRedColor">کد ملی را وارد نمائید.</small>
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">شماره بیمه</label>
          <input formControlName="shomareh_bimeh" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">پدر</label>
          <input formControlName="name_Pedar" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">شغل پدر</label>
          <input formControlName="shoghleh_Pedar" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

      </div>

      <div class="row">

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">
            شماره همراه (بدون صفر اول)
            <button (click)="OnAdd_shomareh_Hamreh()" type="button"
              [disabled]="!get_Form_shomareh_Hamreh().valid || get_Form_shomareh_Hamreh().value =='' || get_Form_shomareh_Hamreh().value == null "
              class="btn  btn-success"><i class="fa  fa-plus-circle"></i> </button>
          </label>
          <input formControlName="shomareh_Hamreh" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_shomareh_Hamreh().valid && get_Form_shomareh_Hamreh().touched"
            class="form-text text-muted MyErrorRedColor">شماره همراه را وارد نمائید.</small>
          <table class="mb-0 table table-bordered table-3 text-center table-striped"
            *ngIf="Person_shomareh_Hamreh_Array.length>0">
            <tr class="bg-warning" *ngFor="let item of Person_shomareh_Hamreh_Array">
              <td>
                {{item.title}}
              </td>
              <td>
                <a style="cursor: pointer;" (click)="Person_shomareh_Hamreh_Delete(item.id)"><i
                    class="fa fa-remove"></i> حذف </a>
              </td>
            </tr>
          </table>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">مسکن </label>
          <select class="custom-select" formControlName="maskan">
            <option value="0">انتخاب کنید</option>
            <option value="1">شخصی</option>
            <option value="2">استیجاری</option>
            <option value="3">با اقوام زندگی می‌کند</option>
          </select>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">
            ایمیل
            <button (click)="OnAdd_email()" type="button"
              [disabled]="!get_Form_email().valid || get_Form_email().value =='' || get_Form_email().value == null "
              class="btn  btn-success"><i class="fa  fa-plus-circle"></i> </button>
          </label>
          <input formControlName="email" type="email" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_email().valid && get_Form_email().touched"
            class="form-text text-muted MyErrorRedColor">ایمیل را وارد نمائید.</small>
          <table class="mb-0 table table-bordered table-3 text-center table-striped"
            *ngIf="Person_email_Array.length>0">
            <tr class="bg-warning" *ngFor="let item of Person_email_Array">
              <td>
                {{item.title}}
              </td>
              <td>
                <a style="cursor: pointer;" (click)="Person_email_Delete(item.id)"><i class="fa fa-remove"></i> حذف </a>
              </td>
            </tr>
          </table>
        </div>



      </div>

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">
            آدرس منزل فعلی
            <button (click)="OnAdd_address_Manzel()" type="button"
              [disabled]="!get_Form_address_Manzel().valid || get_Form_address_Manzel().value =='' || get_Form_address_Manzel().value == null "
              class="btn  btn-success"><i class="fa  fa-plus-circle"></i> </button>
          </label>
          <input formControlName="address_Manzel" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <table class="mb-0 table table-bordered table-3 text-center table-striped"
            *ngIf="Person_address_Manzel_Array.length>0">
            <tr class="bg-warning" *ngFor="let item of Person_address_Manzel_Array">
              <td>
                {{item.title}}
              </td>
              <td>
                <a style="cursor: pointer;" (click)="Person_address_Manzel_Delete(item.id)"><i class="fa fa-remove"></i>
                  حذف </a>
              </td>
            </tr>
          </table>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">
            کدپستی
            <button (click)="OnAdd_codeposti()" type="button"
              [disabled]="!get_Form_codeposti().valid || get_Form_codeposti().value =='' || get_Form_codeposti().value == null "
              class="btn  btn-success"><i class="fa  fa-plus-circle"></i> </button>
          </label>
          <input formControlName="codeposti" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <table class="mb-0 table table-bordered table-3 text-center table-striped"
            *ngIf="Person_codeposti_Array.length>0">
            <tr class="bg-warning" *ngFor="let item of Person_codeposti_Array">
              <td>
                {{item.title}}
              </td>
              <td>
                <a style="cursor: pointer;" (click)="Person_codeposti_Delete(item.id)"><i class="fa fa-remove"></i> حذف
                </a>
              </td>
            </tr>
          </table>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">
            تلفن
            <button (click)="OnAdd_tel()" type="button"
              [disabled]="!get_Form_tel().valid || get_Form_tel().value =='' || get_Form_tel().value == null "
              class="btn  btn-success"><i class="fa  fa-plus-circle"></i> </button>
          </label>
          <input formControlName="tel" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
          <table class="mb-0 table table-bordered table-3 text-center table-striped" *ngIf="Person_tel_Array.length>0">
            <tr class="bg-warning" *ngFor="let item of Person_tel_Array">
              <td>
                {{item.title}}
              </td>
              <td>
                <a style="cursor: pointer;" (click)="Person_tel_Delete(item.id)"><i class="fa fa-remove"></i> حذف </a>
              </td>
            </tr>
          </table>
        </div>

      </div>

      <div class="row" [hidden]="get_Form_Sex().value!='1'">

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">وضعیت نظام وظیفه</label>
          <select class="custom-select" formControlName="vaziat_Nazam_Vazifeh">
            <option value="0">انتخاب کنید</option>
            <option value="1">شده</option>
            <option value="2">معافیت موقت</option>
            <option value="3">معافیت دائمی</option>
          </select>
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">توضیحات وضعیت نظام وظیفه</label>
          <input formControlName="vaziat_Nazam_Vazifeh_Dsc" type="text" class="form-control"
            placeholder="اینجا تایپ کنید ...">
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">از تاریخ </label>
          <input formControlName="vaziat_startDate" #vaziat_startDateInput type="text" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="vaziat_startDateInput"></ng-persian-datepicker>
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تا تاریخ </label>
          <input formControlName="vaziat_endDate" #vaziat_endDateInput type="text" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="vaziat_endDateInput"></ng-persian-datepicker>
        </div>

      </div>

      <div class="row" [hidden]="get_Form_vaziat_Tahol().value!='1'">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">نام همسر</label>
          <input formControlName="name_Hamsar" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تعداد فرزندان</label>
          <input formControlName="tedadFarzandan" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">کد ملّی همسر (بدون صفر اول) </label>
          <input formControlName="codeMeli_Hamsar" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_codeMeli_Hamsar().valid && get_Form_codeMeli_Hamsar().touched"
            class="form-text text-muted MyErrorRedColor">کد ملّی همسر را وارد نمائید.</small>
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">
            شماره همراه همسر (بدون صفر اول)
            <button (click)="OnAdd_shomareh_hamrah_Hamsar()" type="button"
              [disabled]="!get_Form_shomareh_hamrah_Hamsar().valid || get_Form_shomareh_hamrah_Hamsar().value =='' || get_Form_shomareh_hamrah_Hamsar().value == null "
              class="btn  btn-success"><i class="fa  fa-plus-circle"></i> </button>
          </label>
          <input formControlName="shomareh_hamrah_Hamsar" type="number" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_shomareh_hamrah_Hamsar().valid && get_Form_shomareh_hamrah_Hamsar().touched"
            class="form-text text-muted MyErrorRedColor">شماره همراه همسر را وارد نمائید.</small>
          <table class="mb-0 table table-bordered table-3 text-center table-striped"
            *ngIf="Person_shomareh_hamrah_Hamsar_Array.length>0">
            <tr class="bg-warning" *ngFor="let item of Person_shomareh_hamrah_Hamsar_Array">
              <td>
                {{item.title}}
              </td>
              <td>
                <a style="cursor: pointer;" (click)="Person_shomareh_hamrah_Hamsar_Delete(item.id)"><i
                    class="fa fa-remove"></i> حذف </a>
              </td>
            </tr>
          </table>
        </div>

      </div>

      <div class="row" [hidden]="get_Form_vaziat_Tahol().value!='1'">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">تحصیلات همسر</label>
          <select class="custom-select" formControlName="tahsilat_Hamsar">
            <option value="0">انتخاب کنید</option>
            <option value="1">سیکل</option>
            <option value="2">دیپلم</option>
            <option value="3">کاردانی</option>
            <option value="4">کارشناسی</option>
            <option value="5">کارشناسی ارشد</option>
            <option value="6">دکتری</option>
          </select>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">تاریخ تولد همسر</label>
          <input formControlName="tarikh_Tavalod_Hamsar" #tarikh_Tavalod_HamsarInput type="text" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="tarikh_Tavalod_HamsarInput"></ng-persian-datepicker>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">شغل همسر</label>
          <input formControlName="shoghleh_Hamsar" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

      </div>

      <div class="row" >
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">تاریخ تولد </label>
          <input formControlName="tarikh_Tavalod" #tarikh_Tavalod_Input type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="tarikh_Tavalod_Input"></ng-persian-datepicker>
        </div>
      </div>

      <br>
      <br>
      <hr>
      <br>
      <h4>بارگذاری مدارک</h4>
      <br>

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">
            کارت ملی1
            <button (click)="Remove_uploadcodemeli_Image1()" type="button" *ngIf="Edit_Record_Persone.codemeli_Image1"
              class="btn  btn-danger"><i class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_codemeli_Image1" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_codemeli_Image1" #file_codemeli_Image1
            (change)="uploadcodemeli_Image1(file_codemeli_Image1.files)" type="file" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <img (click)="openModal(templateImage,Edit_Record_Persone.codemeli_Image1)"
            *ngIf="Edit_Record_Persone.codemeli_Image1" style="width: 150px;cursor: zoom-in;"
            src="{{BaseUrl}}File/Person/{{Edit_Record_Persone.codemeli_Image1}}" />
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">
            کارت ملی2
            <button (click)="Remove_uploadcodemeli_Image2()" type="button" *ngIf="Edit_Record_Persone.codemeli_Image2"
              class="btn  btn-danger"><i class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_codemeli_Image2" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_codemeli_Image2" #file_codemeli_Image2
            (change)="uploadcodemeli_Image2(file_codemeli_Image2.files)" type="file" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <img (click)="openModal(templateImage,Edit_Record_Persone.codemeli_Image2)"
            *ngIf="Edit_Record_Persone.codemeli_Image2" style="width: 150px;cursor: zoom-in;"
            src="{{BaseUrl}}File/Person/{{Edit_Record_Persone.codemeli_Image2}}" />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">
            شناسنامه 1
            <button (click)="Remove_uploadshenasNameh_Image1()" type="button"
              *ngIf="Edit_Record_Persone.shenasNameh_Image1" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_shenasNameh_Image1" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_shenasNameh_Image1" #file_shenasNameh_Image1
            (change)="uploadshenasNameh_Image1(file_shenasNameh_Image1.files)" type="file" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <img (click)="openModal(templateImage,Edit_Record_Persone.shenasNameh_Image1)"
            *ngIf="Edit_Record_Persone.shenasNameh_Image1" style="width: 150px;cursor: zoom-in;"
            src="{{BaseUrl}}File/Person/{{Edit_Record_Persone.shenasNameh_Image1}}" />
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">
            شناسنامه 2
            <button (click)="Remove_uploadshenasNameh_Image2()" type="button"
              *ngIf="Edit_Record_Persone.shenasNameh_Image2" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_shenasNameh_Image2" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_shenasNameh_Image2" #file_shenasNameh_Image2
            (change)="uploadshenasNameh_Image2(file_shenasNameh_Image2.files)" type="file" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <img (click)="openModal(templateImage,Edit_Record_Persone.shenasNameh_Image2)"
            *ngIf="Edit_Record_Persone.shenasNameh_Image2" style="width: 150px;cursor: zoom-in;"
            src="{{BaseUrl}}File/Person/{{Edit_Record_Persone.shenasNameh_Image2}}" />
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">
            شناسنامه 3
            <button (click)="Remove_uploadshenasNameh_Image3()" type="button"
              *ngIf="Edit_Record_Persone.shenasNameh_Image3" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_shenasNameh_Image3" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_shenasNameh_Image3" #file_shenasNameh_Image3
            (change)="uploadshenasNameh_Image3(file_shenasNameh_Image3.files)" type="file" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <img (click)="openModal(templateImage,Edit_Record_Persone.shenasNameh_Image3)"
            *ngIf="Edit_Record_Persone.shenasNameh_Image3" style="width: 150px;cursor: zoom-in;"
            src="{{BaseUrl}}File/Person/{{Edit_Record_Persone.shenasNameh_Image3}}" />
        </div>

      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">
            کارت پایان خدمت
            <button (click)="Remove_uploadkartPayan_Khadamt_Image()" type="button"
              *ngIf="Edit_Record_Persone.kartPayan_Khadamt_Image" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_kartPayan_Khadamt_Image" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_kartPayan_Khadamt_Image" #file_kartPayan_Khadamt_Image
            (change)="uploadkartPayan_Khadamt_Image(file_kartPayan_Khadamt_Image.files)" type="file"
            class="form-control" placeholder="اینجا تایپ کنید ...">
          <img (click)="openModal(templateImage,Edit_Record_Persone.kartPayan_Khadamt_Image)"
            *ngIf="Edit_Record_Persone.kartPayan_Khadamt_Image" style="width: 150px;cursor: zoom-in;"
            src="{{BaseUrl}}File/Person/{{Edit_Record_Persone.kartPayan_Khadamt_Image}}" />
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">
            فرم سوء پیشینه
            <button (click)="Remove_uploadform_soe_Pishineh_Image()" type="button"
              *ngIf="Edit_Record_Persone.form_soe_Pishineh_Image" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_form_soe_Pishineh_Image" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_form_soe_Pishineh_Image" #file_form_soe_Pishineh_Image
            (change)="uploadform_soe_Pishineh_Image(file_form_soe_Pishineh_Image.files)" type="file"
            class="form-control" placeholder="اینجا تایپ کنید ...">
          <img (click)="openModal(templateImage,Edit_Record_Persone.form_soe_Pishineh_Image)"
            *ngIf="Edit_Record_Persone.form_soe_Pishineh_Image" style="width: 150px;cursor: zoom-in;"
            src="{{BaseUrl}}File/Person/{{Edit_Record_Persone.form_soe_Pishineh_Image}}" />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">
            عکس پرسنلی
            <button (click)="Remove_uploadax_Personeli_Image()" type="button"
              *ngIf="Edit_Record_Persone.ax_Personeli_Image" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_ax_Personeli_Image" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_ax_Personeli_Image" #file_ax_Personeli_Image
            (change)="uploadax_Personeli_Image(file_ax_Personeli_Image.files)" type="file" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <img (click)="openModal(templateImage,Edit_Record_Persone.ax_Personeli_Image)"
            *ngIf="Edit_Record_Persone.ax_Personeli_Image" style="width: 150px;cursor: zoom-in;"
            src="{{BaseUrl}}File/Person/{{Edit_Record_Persone.ax_Personeli_Image}}" />
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">
            عکس پرسنلی2
            <button (click)="Remove_uploadax_Personeli_Image2()" type="button"
              *ngIf="Edit_Record_Persone.ax_Personeli_Image2" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_ax_Personeli_Image2" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_ax_Personeli_Image2" #file_ax_Personeli_Image2
            (change)="uploadax_Personeli_Image2(file_ax_Personeli_Image2.files)" type="file" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <img (click)="openModal(templateImage,Edit_Record_Persone.ax_Personeli_Image2)"
            *ngIf="Edit_Record_Persone.ax_Personeli_Image2" style="width: 150px;cursor: zoom-in;"
            src="{{BaseUrl}}File/Person/{{Edit_Record_Persone.ax_Personeli_Image2}}" />
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">
            امضاء
            <button (click)="Remove_uploadax_Sign_Image()" type="button" *ngIf="Edit_Record_Persone.sign_image"
              class="btn  btn-danger"><i class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_ax_Sign_Image" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_ax_Sign_Image" #file_ax_Sign_Image
            (change)="uploadax_Sign_Image(file_ax_Sign_Image.files)" type="file" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <img (click)="openModal(templateImage,Edit_Record_Persone.sign_image)" *ngIf="Edit_Record_Persone.sign_image"
            style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Edit_Record_Persone.sign_image}}" />
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">
            فرم رزومه برای مصاحبه
            <button (click)="Remove_uploadform_reserve_mosahebeh_Image()" type="button"
              *ngIf="Edit_Record_Persone.form_reserve_mosahebeh_Image" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_form_reserve_mosahebeh_Image" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_form_reserve_mosahebeh_Image" #file_form_reserve_mosahebeh_Image
            (change)="uploadform_reserve_mosahebeh_Image(file_form_reserve_mosahebeh_Image.files)" type="file"
            class="form-control" placeholder="اینجا تایپ کنید ...">
          <img (click)="openModal(templateImage,Edit_Record_Persone.form_reserve_mosahebeh_Image)"
            *ngIf="Edit_Record_Persone.form_reserve_mosahebeh_Image" style="width: 150px;cursor: zoom-in;"
            src="{{BaseUrl}}File/Person/{{Edit_Record_Persone.form_reserve_mosahebeh_Image}}" />
        </div>
      </div>

      <br>
      <br>
      <hr>
      <br>
      <h4>جایگاه در بهینه فرآیند آزما</h4>
      <br>
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">تاریخ استخدام در بهینه (*)</label>
          <input formControlName="tarikh_Eshtekhdam" #tarikh_EshtekhdamInput type="text" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="tarikh_EshtekhdamInput"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">علامت اختصاری در بهینه فرآیند آزما (*) </label>
          <input formControlName="almat_Ekhtesari" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_almat_Ekhtesari().valid && get_Form_almat_Ekhtesari().touched"
            class="form-text text-muted MyErrorRedColor">علامت اختصاری در بهینه فرآیند آزما را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">سابق قبل بهفا(سال)</label>
          <input formControlName="sabegh" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">محل فعالیت</label>
          <select class="custom-select" formControlName="field_activity_id">
            <option value="0">انتخاب کنید</option>
            <option value="1">داخل آزمایشگاه</option>
            <option value="2">خارج آزمایشگاه</option>
            <option value="3">داخل/خارج آزمایشگاه</option>
            <option value="4">اداری</option>
            <option value="5">مالی</option>
          </select>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">سمت</label>
          <select class="custom-select" formControlName="semat_id">
            <option value="0">انتخاب کنید</option>
            <option *ngFor="let item of DataList_Semat" [value]="item.id">{{item.title}}</option>
          </select>
        </div>
      </div>



    </form>



    <br>
    <br>

    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!InProccessing" type="button" (click)="SubmitEditNewPerson()" [disabled]="!EditNewPerson.valid"
      class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
    <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-left: 5px;"><i
        class="fa fa-times-rectangle"></i> لغو </button>
    <button routerLink="/Person" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
        class="fa fa-mail-reply"></i> بازگشت </button>
  </div>
</div>


<ng-template #templateImage>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> نمایش عکس </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img style="max-width: 350px;" src="{{BaseUrl}}File/Person/{{ModalimageUrl}}" />
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Person/{{ModalimageUrl}}"><i
        class="fa fa-download"></i> دانلود </a>
    <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">بستن</button>
  </div>
</ng-template>
